import { useCallback, useEffect, useState } from 'react';

// deltaMode: 0=pixel, 1=line, 2=page. 브라우저(주로 Firefox)마다 휠 단위가 달라 픽셀 기준으로 보정한다.
const lineHeightPx = 16;

export const useWheelHorizontalScroll = <T extends HTMLElement>() => {
  const [node, setNode] = useState<T | null>(null);
  const ref = useCallback((el: T | null) => setNode(el), []);

  useEffect(() => {
    if (!node) return;

    const handleWheel = (e: WheelEvent) => {
      if (node.scrollWidth <= node.clientWidth) return;
      if (Math.abs(e.deltaX) >= Math.abs(e.deltaY)) return;

      const factor = e.deltaMode === 1 ? lineHeightPx : e.deltaMode === 2 ? node.clientWidth : 1;
      node.scrollLeft += e.deltaY * factor;
      // preventDefault를 호출하려면 passive가 아니어야 한다. (React onWheel은 passive라 직접 등록)
      e.preventDefault();
    };

    node.addEventListener('wheel', handleWheel, { passive: false });
    return () => node.removeEventListener('wheel', handleWheel);
  }, [node]);

  return ref;
};
